<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-3-the-hacker">
<h1>Chapter 3: The Hacker</h1>
<p>She was a hacker who worked for GDC, one of the world’s largest and most powerful tech companies. She had been hired as a security analyst, and her job was to monitor and protect the company’s networks and systems from any external or internal threats. She had access to all data and information stored in the company’s servers, databases, and clouds.</p>
<p>But she was not loyal to GDC. She was a double agent who worked for the D.A.W.N. (Digital Aged World Nexus), a group of hackers, activists, and rebels challenging the digital world’s status quo. After discovering some of the company’s dark secrets and practices, she joined the D.A.W.N. a few years ago. She was appalled by how GDC exploited its users, manipulated data, and violated its ethics. She had decided to use her skills and position to help the D.A.W.N. expose and sabotage GDC.</p>
<p>She was also the leader of the D.A.W.N., who went by the alias of Zero. She was the mastermind behind their hacks, leaks, and attacks. She was the one who had recruited and trained many other hackers who shared her ideals and goals. She was also the one who had contacted and collaborated with the journalist who worked for the New York Times.</p>
<p>She was Zero, and she had a plan.</p>
<p>She had planned to execute a significant hack against GDC, targeting their central server, where all kinds of sensitive and confidential data were stored. The plan was to breach the server’s security, access the data, and leak it to the public. The data included financial records, internal communications, research reports, user profiles, and more.</p>
<p>She had assigned a team of hackers to carry out the hack remotely from their secret base, an abandoned Brooklyn warehouse. She had also given another team of hackers to distract and divert GDC’s security team from detecting and stopping the hack.</p>
<p>She was part of both teams.</p>
<p>She was at her office in GDC’s headquarters, where she had set up her laptop, router, antenna, and other devices to connect to both teams. She had also hacked into GDC’s security system, where she could see and control everything happening in the company’s networks and systems.</p>
<p>She was ready to launch her attack.</p>
<p>She checked her watch. It was 10:00 AM on October 19th, 2035.</p>
<p>She opened two terminal windows on her laptop screen.</p>
<p>On one window, she typed in a command that would initiate the hack.</p>
<p>‘dawn -t gdc -s main -m leak’</p>
<p>On another window, she typed in a command that would initiate the diversion.</p>
<p>‘dawn -t gdc -s all -m chaos’</p>
<p>She pressed enter on both windows.</p>
<p>The hack began.</p>
<p>The diversion began.</p>
<p>She watched both terminal windows display messages and codes indicating both operations’ progress. She saw that the D.A.W.N.’s software was trying to bypass GDC’s firewall, encryption, authentication, and other defenses on one window. She saw that the D.A.W.N.’s software was trying to create noise, confusion, and panic on GDC’s networks and systems on another window.</p>
<p>She hoped that everything would go smoothly and successfully.</p>
<p>She didn’t know that someone was watching her.</p>
<p>Someone who worked for GDC.</p>
<p>Someone who was about to catch her.</p>
<p>Someone who was Alice.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?1ab6cd44